import { render, staticRenderFns } from "./cadtransferenciasfiliais.vue?vue&type=template&id=ae57dcd0&"
import script from "./cadtransferenciasfiliais.vue?vue&type=script&lang=js&"
export * from "./cadtransferenciasfiliais.vue?vue&type=script&lang=js&"
import style0 from "./cadtransferenciasfiliais.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports